import React, { useState } from 'react';
import { toast } from 'react-toastify';
import jm, { errorMessage, formatDateTime } from '../api';
import CandidateTable, { RowActions } from '../common/CandidateTable';
import { MonthField } from '../common/DateField';

/** The stage each report option reads, matching the old report filter. */
const STATUSES = [
  { value: 1, label: 'Shortlisted' },
  { value: 6, label: 'Demo' },
  { value: 2, label: 'Interviewed' },
  { value: 3, label: 'Final Recruit' },
  { value: 4, label: 'Rejected' },
  { value: 5, label: 'Hold' },
];

const Report = () => {
  const [monthYear, setMonthYear] = useState(new Date().toISOString().slice(0, 7));
  const [status, setStatus] = useState(1);
  const [rows, setRows] = useState([]);
  const [label, setLabel] = useState('');
  const [loading, setLoading] = useState(false);
  const [ran, setRan] = useState(false);

  const run = async () => {
    setLoading(true);

    try {
      const result = await jm.report(monthYear, status);
      setRows(result.data || []);
      setLabel(result.status_label || '');
      setRan(true);
    } catch (error) {
      toast.error(errorMessage(error, 'Could not build the report'));
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { key: 'action', label: 'Action', search: false, sortable: false, render: (row) => <RowActions row={row} /> },
    { key: 'first_name', label: 'Name', render: (row) => [row.first_name, row.last_name].filter(Boolean).join(' ') },
    { key: 'contact_no', label: 'Contact Number' },
    { key: 'email', label: 'Email' },
    { key: 'address', label: 'Address' },
    { key: 'qualification', label: 'Qualification' },
    { key: 'experience', label: 'Experience' },
    { key: 'stage_notes', label: 'Remark' },
    { key: 'job_status', label: 'Job Status', search: false, sortable: false, render: () => label },
    { key: 'stage_date', label: 'Date', render: (row) => formatDateTime(row.stage_date) },
  ];

  return (
    <>
      <div className="card mb-3">
        <div className="card-header"><h6 className="mb-0">Filter by Recruitment Report</h6></div>
        <div className="card-body">
          <div className="row align-items-end">
            <div className="col-md-3 form-group mb-0">
              <label>Select Month / Year</label>
              <MonthField value={monthYear} onChange={setMonthYear} />
            </div>
            <div className="col-md-3 form-group mb-0">
              <label>Status</label>
              <select className="form-control" value={status} onChange={(e) => setStatus(Number(e.target.value))}>
                {STATUSES.map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
            </div>
            <div className="col-md-2 form-group mb-0">
              <button type="button" className="btn btn-primary btn-block" onClick={run} disabled={loading}>
                {loading ? 'Loading…' : 'Get'}
              </button>
            </div>
          </div>
        </div>
      </div>

      <CandidateTable
        title={`Recruitment Report${label ? ` — ${label}` : ''}`}
        rows={rows}
        columns={columns}
        loading={loading}
        emptyText={ran ? 'No candidates for that month and status.' : 'Pick a month and status, then press Get.'}
        exportName="recruitment_report"
      />
    </>
  );
};

export default Report;
